import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";

export {init}
Html.registerWidget('widget/copyprevtext',{init:init})

function init(obj){
  var subselector=obj.data('subselector');
  obj.get(0).style.cursor = 'pointer';
  obj.on('click',function(event){
    event.preventDefault();
    var 
      prevnode = subselector?obj.prev().find(subselector):obj.prev();
    
    navigator.clipboard.writeText(prevnode.text()).then(dunowhat=>{
      obj.get(0).style.backgroundColor='#8ec549';
      obj.html(i18n.get('invite_link.copied'))
    })
    
  })
}